///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { TunnelTypeEnum } from '../../../../../generated/shared-types.model';
import { TunnelModel } from './tunnel.model';

export class TunnelsWithTypeModel {
    constructor(
        public type: TunnelTypeEnum,
        public tunnels: TunnelModel[]
    ) {}
}
